import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "CardSpotlightSocialOfferStack";
export const classes = {
  hover: `${PREFIX}-hover`,
  root: `${PREFIX}-root`,
};

export const CardSpotlightSocialOfferStack = styled(Stack)(({ theme }) => ({
  [`&.${classes.hover}`]: {
    cursor: "pointer",
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
  [`&.${classes.root}`]: {
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    borderRadius: "5px",
    border: `2px solid ${theme.palette.primary.main}`,
    flex: "1 1 auto",
    height: "fit-content",
  },
}));
